import { DEFAULT_LOCALE } from '@/constants';
import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import nl from './locales/nl.json';

const i18n = createI18n({
    legacy: false,
    locale: localStorage.getItem('locale') || DEFAULT_LOCALE,
    fallbackLocale: DEFAULT_LOCALE,
    messages: {
        en,
        nl,
    },
});

export default i18n;
